import axios from "axios";
import { useCallback, useEffect, useState } from "react";

export const BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const skip = /\/auth\/(login|register|refresh|logout)/.test(cfg.url || "");
    if (err.response?.status === 401 && !cfg._retry && !skip) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  if (!e?.response) return "Connessione al server non riuscita. Riprova.";
  const d = e.response.data?.detail;
  if (d == null) return "Si è verificato un errore. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const wsUrl = (path) => `${BASE.replace(/^http/, "ws")}/api${path}`;

export function useFetch(url, params) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const key = JSON.stringify(params || {});
  const reload = useCallback(() => {
    setState((s) => ({ ...s, loading: true }));
    return api
      .get(url, { params: JSON.parse(key) })
      .then((r) => setState({ data: r.data, loading: false, error: null }))
      .catch((e) => setState({ data: null, loading: false, error: errMsg(e) }));
  }, [url, key]);
  useEffect(() => {
    if (url) {
      reload();
    }
  }, [url, reload]);
  return { ...state, reload };
}
